import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider, useDispatch, useSelector } from 'react-redux';
// eslint-disable-next-line import/no-named-as-default-member
import MasterContextProvider from '../../../contexts/MasterContext/MasterContextProvider';
import 'bootstrap/dist/css/bootstrap.min.css';
import ToastNotificationWrapperConnected from '../ToastNotificationWrapperConnected/ToastNotificationWrapperConnected';
import MainLayout from '../MainLayout/MainLayout';
import ModalContainer from '../Modals/ModalContainer/ModalContainer';
import { store } from '../../../redux/store';
import { fetchThresholds } from '../../../redux/slices/thresholdRangeSlice/thresholdRangeSlice';
import { fetchProducts } from '../../../redux/slices/productsSlice/productsSlice';
import { fetchDeviceListData } from '../../../redux/slices/deviceList/deviceListSlice';
import { fetchAlertEvents } from '../../../redux/slices/alertEvents/alertEventsSlice';
import { fetchMetricGroups } from '../../../redux/slices/metricsGroupSlice/metricsGroupSlice';
import { fetchJWT } from '../../../redux/slices/jwtSlice';
import { fetchSubscriptionUserList } from '../../../redux/slices/conversation/conversationSlice';
import { fetchNotificationGroups } from '../../../redux/slices/notificationGroupsSlice/notificationGroupsSlice';
import {
  fetchSessionData,
  fetchUserMessages,
  selectIsAuthenticated,
  selectSessionInformation,
} from '../../../redux/slices/sessionSlice';
import { fetchQuietTimes } from '../../../redux/slices/quietTimesSlice/quietTimesSlice';
import { RaaRoles, sessionUserHasRolePrivileges } from '../../../utility/SecurityRules';
import { fetchNotificationTemplates } from '../../../redux/slices/notificationTemplatesSlice/notificationTemplatesSlice';
import { fetchServicePlan } from '../../../redux/slices/billingSlice/billingSlice';
import {
  fetchChecklistCompletionStats, fetchSubscriptionChecklists,
} from '../../../redux/slices/subscriptionChecklistSlice/subscriptionChecklistSlice';

function App() {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const { activeSubscription } = useSelector(selectSessionInformation);

  React.useEffect(() => {
    dispatch(fetchJWT());
    dispatch(fetchSessionData());
  }, []);

  React.useEffect(() => {
    let intervalId2;
    let intervalId3;

    const isLapsedAccount = !activeSubscription || activeSubscription.subscriptionTierLevel <= 0;
    if (isAuthenticated) {
      if (sessionUserHasRolePrivileges(activeSubscription,
        [RaaRoles.ADMIN, RaaRoles.MANAGER, RaaRoles.VIEWER, RaaRoles.PROVISIONER])
        && !isLapsedAccount) {
        dispatch(fetchThresholds());
        intervalId3 = setInterval(() => dispatch(fetchProducts()), 5000);
        dispatch(fetchDeviceListData());
        dispatch(fetchAlertEvents());
        dispatch(fetchMetricGroups());
        dispatch(fetchNotificationGroups());
        dispatch(fetchQuietTimes());
        dispatch(fetchNotificationTemplates());
        dispatch(fetchChecklistCompletionStats());
        dispatch(fetchSubscriptionChecklists());
      }
      if (sessionUserHasRolePrivileges(activeSubscription,
        [RaaRoles.ADMIN, RaaRoles.PROVISIONER, RaaRoles.BILLING]) && !isLapsedAccount) {
        dispatch(fetchServicePlan());
      }
      dispatch(fetchUserMessages());
      dispatch(fetchSubscriptionUserList());
    }
    return () => {
      clearInterval(intervalId2);
      clearInterval(intervalId3);
    };
  }, [isAuthenticated, activeSubscription]);

  return (
    <Provider store={store}>
      <BrowserRouter>
        <MasterContextProvider>
          <MainLayout />
          <ToastNotificationWrapperConnected />
          <ModalContainer />
        </MasterContextProvider>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
